import { DischargeAmountType } from './DischargeAmountType';

class DischargeScale {
  constructor(data = {}) {
    if (data.dischargeSequenceId) {
      this.dischargeSequenceId = data.dischargeSequenceId;
    }
    this.scaleId = data.scaleId;
    this.scaleName = data.scaleName;
    this.type = data.type;
    this.unit = data.unit;
    this.target = data.target;
    this.isPrimary = data.isPrimary;
    this.order = data.order;
    this.flowRate = data.flowRate || 0;
    this.delay = data.delay || 0;
    this.start = this.isPrimary ? 0 : data.start;
    this.finish = this.isPrimary ? 100 : data.finish;
    this.withWater = typeof data.withWater === 'boolean' ? data.withWater : true;
    this.noWait = data.noWait || false;
    this.waitForAdmix = data.waitForAdmix || false;
    this.washStart = data.washStart || 0;

    if (this.isPrimary) {
      this.startAtHeadWater = data.startAtHeadWater || 0;
      this.washAmount = data.washAmount || 0;
      this.washAmountType = data.washAmountType || DischargeAmountType.Unit;
      this.holdAmount = data.holdAmount || 0;
      this.holdAmountType = data.holdAmountType || DischargeAmountType.Unit;
      this.holdForScaleId = data.holdForScaleId || null;
      this.resumeAmount = data.resumeAmount || 100;
      this.resumeAmountType = data.resumeAmountType || DischargeAmountType.Percent;
    }
  }
}

export default DischargeScale;
